import React from 'react'

import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default class SaisieLibreMultiple extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} style={{padding: '5px 0'}} title={this.props.title} buttons={
        !this.props.disabled && <button type="button" onClick={this.props.onClickSaisieLibreMultipleBool} className="text-success ei-commun_ajouter"
                disabled={this.props.disabled || false}
                style={{ display: this.props.disabled && 'none' || 'inline-block', marginLeft: 5 }}/>}>
        {
          (this.props.data || []).map((data, index) => (

            <Grid key={index} container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
                  alignItems={'center'}>
              <Grid item  style={{ margin: 0, padding: 0, display: this.props.disabled && 'none' || 'inline-block' }}>
                <button type="button" onClick={() => this.props.onClickRemoveSaisieLibreMultipleBool(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={this.props.disabled || false}/>
              </Grid>
              <Grid item xs style={{ margin: 0, padding: 0 }}>
                <Traduction style={this.props.style}
                  onChange={(e) => this.props.onChangeSaisieLibeMultipleBool(e, index)}
                  disabled={this.props.disabled || false}
                  name={'text'}
                  data={data.text !== undefined ? data.text : []}
                  type={Constants.typeSaisie.SaisieLibre}
                />
              </Grid>
              <Grid item
                    style={{ margin: 0, padding: 0, display: !this.props.media_lien && 'none' }}>
                <a className={'ei-crm_public'} target="_blank" rel="noopener noreferrer"
                   href={data.text !== undefined ? data.text[0] && data.text[0].text : ''}/>
              </Grid>
            </Grid>
          ))
        }
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/SaisieLibre/SaisieLibreMultiple.js